import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import {Typography, Box} from "@material-ui/core";
import Navbar from "./Navbar"; 

const useStyles = makeStyles(theme=>({
    mainContainer:{
        background: "rgba(255,255,255,.8)"
    },

    // timeLine

    timeLine: {
        position: "relative",
        padding: "1rem",
        margin: "0 auto",
        "&:before": {
            content: "''",
            position: "absolute", 
            height: "100%",
            borderLeft: "4px solid #41424c",
            right: "40px",
            top:0
            },
            "&:after": {
                content: "''",
                display: "table",
                clear: "both"
            },
            [theme.breakpoints.up("md")]: {
            padding: "2rem",
            "&:before": {
                left: "calc(50% - 1px)",
                right: "auto"
            }
        }
    },

    // timeLineItem

    timeLineItem: {
        padding: "1rem",
        borderBottom: "2px solid #41424c",
        position: "relative",
        margin: "1rem 3rem 1rem 1rem",
        clear: "both",
        "&:after": {
            content:"''",
            position: "absolute"
        },
        "&:before": {
            content: "''",
            position: "absolute",
            right: "-0.625rem",
            top: "calc(50% - 5px)",
            borderStyle: "solid",
            borderColor: "#101820FF #101820FF transparent transparent",
            borderWidth: "0.625rem",
            transform: "rotate(45deg)"
        },
        [theme.breakpoints.up("md")]: {
            width: "44%",
            margin: "1rem",
            "&:nth-of-type(2n)": {
                float: "right",
                margin: "1rem",
                borderColor: "#41424c",
            },
            "&:nth-of-type(2n):before": {
                right: "auto",
                left: "-0.625rem",
                borderColor:  "transparent transparent #101820FF #101820FF"           
            }
        }
        
    },

    //timeLineYear

    timeLineYear: {
        textAlign: "center",
        maxWidth: "9.375rem",
        margin: "0 3rem 0 auto",
        fontSize: "2.3rem",
        background: "#41424c",
        color: "white",
        lineHeight: 1,
        padding: "0.5rem 0 1rem",
        cursor:"context-menu",
        "&:before": {
            display: "none"
        },
        [theme.breakpoints.up("md")]: {
            textAlign: "center",
            margin: "0 auto",
            "&:nth-of-type(2n)": {
                float: "none",
                margin: "0 auto"
            },
            "&:nth-of-type(2n):before": {
                display: "none"
            }
        }
    },

    heading:{
        color: "#101820FF",
        padding: "2.6rem 0",
        textTransform: "uppercase",
        paddingTop: "6rem",
        cursor:"context-menu",

    },
    subHeading:{
        color: "#12191f",
        padding: "0",
        textTransform: "uppercase",
        cursor:"context-menu"

    },
    officeTitle:{
        color: "#06a94d",
        cursor:"context-menu",
        fontSize: "1rem",
        fontWeight: "700",
        paddingTop: "4px",
        paddingBottom: "4px"
    },
    description:{
        color: "#485063",
        fontSize: "0.9rem"
    }
}));

const TimeLine = () => {

    const classes = useStyles();
    return (
        <>
            <Navbar/>
            <Box component="header" className={classes.mainContainer}>
                <Typography variant="h4" align="center" className={classes.heading}>
                    Experience
                </Typography>
                <Box component="div" className={classes.timeLine}>
                    <Typography variant="h1" className={`${classes.timeLineYear} ${classes.timeLineItem}`}>
                        2022
                    </Typography>

                    <Box component="div" className={classes.timeLineItem}>
                        <Typography variant="h5" className={classes.subHeading}>
                            ASP .Net Core & Xamarin Forms
                        </Typography>
                        <Typography variant="body1" className={classes.officeTitle}>
                            University of Moratwua | Xops, inc.
                        </Typography>
                        <Typography variant="subtitle1" className={classes.description}>
                            For the Level 02 Software Project I studied <b>ASP .Net Core MVC</b> architecture and <b>Xamaring Forms</b>.
                            
                        </Typography>
                    </Box>

                    <Typography variant="h1" className={`${classes.timeLineYear} ${classes.timeLineItem}`}>
                        2021
                    </Typography>

                    <Box component="div" className={classes.timeLineItem}>
                        <Typography variant="h5" className={classes.subHeading}>
                            Web Development (React Js)
                        </Typography>
                        <Typography variant="body1" className={classes.officeTitle}>
                            University of Moratuwa | DivSoft
                        </Typography>
                        <Typography variant="subtitle1" className={classes.description}>
                            Lorem Lorem Lorem LoremLoremLoremLoremLorem Lorem Lorem Lorem Lorem
                        </Typography>
                    </Box>

                    <Typography variant="h2" className={`${classes.timeLineYear} ${classes.timeLineItem}`}>
                        2020
                    </Typography>

                    <Box component="div" className={classes.timeLineItem}>
                        <Typography variant="h5" className={classes.subHeading}>
                            Programming (C)
                        </Typography>
                        <Typography variant="body1" className={classes.officeTitle}>
                            University of Moratuwa
                        </Typography>
                        <Typography variant="subtitle1" className={classes.description}>
                            Lorem Lorem Lorem LoremLoremLoremLoremLorem Lorem Lorem Lorem Lorem
                        </Typography>
                    </Box>

                    <Typography variant="h2" className={`${classes.timeLineYear} ${classes.timeLineItem}`}>
                        2019
                    </Typography>

                    <Box component="div" className={classes.timeLineItem}>
                        <Typography variant="h5" className={classes.subHeading}>
                            Web Design (HTML/CSS/Bootstrap)
                        </Typography>
                        <Typography variant="body1" className={classes.officeTitle}>
                            Self Taught
                        </Typography>
                        <Typography variant="subtitle1" className={classes.description}>
                            Lorem Lorem Lorem LoremLoremLoremLoremLorem Lorem Lorem Lorem Lorem
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </>
    )
}

export default TimeLine;
